import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { PublicationFeedPage } from './publication-feed.page';

const routes: Routes = [
  {
    path: '',
    component: PublicationFeedPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PublicationFeedPageRoutingModule {}
